export function parseUserAgent(ua = navigator.userAgent || '') {
  const browser = detectBrowser(ua);
  const os = detectOS(ua);
  return {
    browser,
    os,
    summary: `${browser} on ${os}`,
  };
}

function detectBrowser(ua) {
  const edge = ua.match(/Edg\/(\d+)/);
  if (edge) return `Edge ${edge[1]}`;
  const opera = ua.match(/OPR\/(\d+)/);
  if (opera) return `Opera ${opera[1]}`;
  const firefox = ua.match(/Firefox\/(\d+)/);
  if (firefox) return `Firefox ${firefox[1]}`;
  const chrome = ua.match(/Chrome\/(\d+)/);
  if (chrome && !/Edg|OPR/.test(ua)) return `Chrome ${chrome[1]}`;
  const safari = ua.match(/Version\/(\d+).*Safari/);
  if (safari) return `Safari ${safari[1]}`;
  return 'Unknown browser';
}

function detectOS(ua) {
  if (/iPad|iPhone|iPod/.test(ua)) {
    const v = ua.match(/OS (\d+)_(\d+)/);
    return v ? `iOS ${v[1]}.${v[2]}` : 'iOS';
  }
  if (/Android/.test(ua)) {
    const v = ua.match(/Android (\d+(?:\.\d+)?)/);
    return v ? `Android ${v[1]}` : 'Android';
  }
  if (/Mac OS X/.test(ua)) {
    const v = ua.match(/Mac OS X (\d+)[._](\d+)/);
    return v ? `macOS ${v[1]}.${v[2]}` : 'macOS';
  }
  if (/Windows NT 10/.test(ua)) return 'Windows 10/11';
  if (/Windows NT/.test(ua)) return 'Windows';
  if (/Linux/.test(ua)) return 'Linux';
  return 'Unknown OS';
}
